var _defs, _g, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerioImplant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282 162.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ab1f24;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.68,95.23H2.98C15.66,64.16,28.35,33.08,41.03,2c62.79.04,125.59.09,188.38.13,16.42,31.03,32.84,62.07,49.26,93.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.81,
    y1: 48.62,
    x2: 254.14,
    y2: 48.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 140.83,
    y1: 2,
    x2: 140.83,
    y2: 160.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.17,
    y1: 2.19,
    x2: 68.09,
    y2: 95.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 187.03,
    y1: 2.18,
    x2: 211.3,
    y2: 95.05
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.98,
    y1: 160.02,
    x2: 275.34,
    y2: 160.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerioImplant);
export default __webpack_public_path__ + "static/media/perio_implant.401e5ab5be07337319fc26019a1b3b8d.svg";
export { ForwardRef as ReactComponent };